module.exports = __webpack_public_path__ + "img/sort-desc.4e9a9b4c.svg";